import classNames from 'classnames'
import { type ReactNode } from 'react'

export default function Navbar ({ children, sidebar, topbar, childrenContainerClassName }: { children: ReactNode, sidebar?: ReactNode, topbar?: ReactNode, childrenContainerClassName?: string }) {
  return (
    <div className="flex w-full">
      <div className="xl:w-[280px] xl:min-w-[280px] w-[180px] border-r border-gray-100 px-[25px] py-1.5 z-10">
        {sidebar}
      </div>
      <div className="flex flex-col min-w-0 min-h-screen w-full">
        {topbar}

        <div className={classNames('px-4 my-4 w-full flex self-center grow min-h-0', childrenContainerClassName)}>
          {children}
        </div>
      </div>
    </div>
  )
}
